"use strict";

// Group all lightbox images on page together.
( () => {
	const selectors = [
		'.elementor-widget-image a[data-elementor-open-lightbox="yes"]',
		'.elementor-widget-image-carousel a[data-elementor-open-lightbox="yes"]'
	];

	const $lightboxImagesLinks = document.querySelectorAll( selectors.join( ', ' ) );

	for ( const $link of $lightboxImagesLinks ) {
		$link.setAttribute( 'data-elementor-lightbox-slideshow', 'all' );
	}
} )();
